export const STENCIL_CORE_ID = '@stencil/core';
export const STENCIL_INTERNAL_ID = '@stencil/core/internal';
export const STENCIL_APP_DATA_ID = '@stencil/core/internal/app-data';
export const STENCIL_APP_GLOBALS_ID = '@stencil/core/internal/app-globals';
export const STENCIL_HYDRATE_FACTORY_ID = '@stencil/core/hydrate-factory';
export const STENCIL_INTERNAL_CLIENT_ID = '@stencil/core/internal/client';
export const STENCIL_INTERNAL_CLIENT_PATCH_BROWSER_ID = '@stencil/core/internal/client/patch-browser';
export const STENCIL_INTERNAL_HYDRATE_ID = '@stencil/core/internal/hydrate';
export const STENCIL_MOCK_DOC_ID = '@stencil/core/mock-doc';
export const APP_DATA_CONDITIONAL = '?app-data=conditional';
export const LAZY_BROWSER_ENTRY_ID = '@lazy-browser-entrypoint' + APP_DATA_CONDITIONAL;
export const LAZY_EXTERNAL_ENTRY_ID = '@lazy-external-entrypoint' + APP_DATA_CONDITIONAL;
export const USER_INDEX_ENTRY_ID = '@user-index-entrypoint';
